import { useState, useEffect } from 'react';
import { MyAccount } from '@cleeng/mediastore-sdk';
import Header from '../../components/Header/Header';
import { usePopupsContext } from '../../components/Popups/Popups';
import $ from 'jquery';
import CleengFooter from '../../components/Footer/CleengFooter';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

const AccountPage = () => {
    const { showModal } = usePopupsContext();
    const [isGiftMode, setIsGiftMode] = useState(false);

    const toggleGiftMode = () => {
        setIsGiftMode(prevMode => {
            const newMode = !prevMode;
            // Re-trigger the plan details modification after state changes
            setTimeout(() => {
                // Check if our custom content exists or the original "No offers yet!" message
                if ($('#startNMPlus').length > 0 || $('.msd__account-content .msd__info-box__title:contains("No offers yet!")').length > 0) {
                    modifyPlanDetailsContent(newMode);
                }
            }, 50);
            return newMode;
        });
    };

    const ModifyMyAccountFields = () => {
        // Wait for CC form to appear
        var selector = '.msd__profile__form #email';

        var emailFieldObserver = new MutationObserver(mutations => {
            if (window.document.querySelector(selector)) {
                if (window.location.pathname !== "/account")
                    emailFieldObserver.disconnect();

                // Perform actions here!
                $('.msd__profile__form label[for=email]').hide();
                $('.msd__profile__form input#email').hide();

                // For account page consents, hide all checkboxes except for the Newsmax T&C
                var newsmaxCheckboxes = [];
                var cleengCheckboxes = [];

                $('.msd__profile-consents__checkbox').each(function () {
                    var ariaLabel = $(this).attr('aria-label');
                    if (ariaLabel && ariaLabel.includes('Terms and Conditions</a> of Newsmax')) {
                        newsmaxCheckboxes.push($(this));
                    } else if (ariaLabel && ariaLabel.includes('Terms and Conditions</a> of Cleeng')) {
                        cleengCheckboxes.push($(this));
                    } else {
                        $(this).hide();
                    }
                });

                newsmaxCheckboxes.forEach(function (checkbox) {
                    checkbox.show();
                });

                cleengCheckboxes.forEach(function (checkbox) {
                    checkbox.show();
                });
            }
        });

        emailFieldObserver.observe(window.document.body, {
            childList: true,
            subtree: true
        });

        const setReactInputValue = (input, value) => {
            const nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
            nativeSetter.call(input, value);
            input.dispatchEvent(new Event('input', { bubbles: true }));
        };

        const toE164 = (value, defaultRegion = 'US') => {
            try {
                const parsed = phoneUtil.parseAndKeepRawInput(value, defaultRegion);
                if (phoneUtil.isValidNumber(parsed)) {
                    return phoneUtil.format(parsed, PhoneNumberFormat.E164);
                }
            } catch (e) { }
            return null;
        };

        var phoneObserver = new MutationObserver(function () {
            const input = document.querySelector('input#phoneNumber');
            if (!input || input._phoneListenerAttached) return;
            input._phoneListenerAttached = true;

            input.addEventListener('blur', function () {
                const e164 = toE164(this.value);
                if (e164 && e164 !== this.value) {
                    setReactInputValue(this, e164);
                }
            });
        });
        phoneObserver.observe(document.body, { childList: true, subtree: true });
    };

    const modifyPlanDetailsContent = (giftMode = isGiftMode) => {
        const giftModeClass = giftMode ? 'justify-content-center' : '';
        const colClass = giftMode ? 'col-12 col-md-6' : 'col-12 col-md-6';
        const monthlyDisplay = giftMode ? 'display: none;' : '';
        const buttonText = giftMode ? 'GIVE A GIFT' : 'SIGN UP NOW';

        const htmlContent = `
      <div class="row py-5" id="startNMPlus">
          <div class="col-10 mx-auto pt-4 pb-5" style="max-width:1000px;">
              <h3 class="mb-4">You do not have an active Newsmax+ subscription</h3>
              <h4 class="mb-3 fw-semibold">Choose a subscription option below. First-time subscribers will receive a 15-day <span class="text-uppercase text-danger">FREE</span> trial – no commitment, cancel anytime.</h4>

              <div class="row">
                  <div class="col-10 mx-auto">
                      <div class="row flex-wrap flex-md-nowrap gap-3 mt-4 align-items-start text-center ${giftModeClass}">
                          <div class="${colClass} border rounded p-0 bg-body">
                            ${giftMode ?
                `
                              <div class="text-left text-dark">
                                <ul class="inline-list text-left" style="text-align: left;">
                                  <li>Click the “Give a Gift” button below</li>
                                  <li>Select Purchase as a gift</li>
                                  <li>Enter Recipient Email and Date / Time of delivery</li>
                                  <li>Add Your Payment Information</li>
                                </ul>
                              </div>
                            `
                : ``
            }
                              <div class="signUpBox rounded p-3 w-100 text-center">
                                  <h3>Yearly</h3>
                                  <h4 class="price ms-3">$49.99 / year</h4>
                               </div>
                               <h5 class="promo pt-3 text-center text-danger fw-bold">Save $10!</h5>
                              <div class="text-start pt-2">
                                  <ul class="lh-2">
                                      <li>Exclusive Content</li>
                                      <li>Breaking News and Expert Analysis</li>
                                      <li>Affordable Pricing</li>
                                      <li>Access From Anywhere, Any Device</li>
                                      <li>15-Day Trial</li>
                                      <li><span class="bg-accent-yellow fw-bold">&nbsp; Lower Annual Price &nbsp;</span></li>
                                  </ul>
                                  <div class="text-center p-1">
                                  <button id="annualSub" class="btn btn-danger btn-lg px-5 mb-3 fw-bold">
                                      ${buttonText}
                                  </button>
                                  </div>
                              </div>
                          </div>

                          <div class="${colClass} border rounded p-0 bg-light" style="${monthlyDisplay}">
                            <div class="signUpBox rounded p-3 w-100 text-center">
                              <h3>Monthly</h3>
                              <h4 class="price ms-3">$4.99 / month</h4>
                            </div>
                            <div class="text-start pt-4">
                              <ul class="lh-2">
                                <li>Exclusive Content</li>
                                <li>Breaking News and Expert Analysis</li>
                                <li>Affordable Pricing</li>
                                <li>Access From Anywhere, Any Device</li>
                                <li>15-Day Trial</li>
                                <li class="invisible">&nbsp;</li>
                              </ul>
                              <div class="text-center p-1">
                                <button id="monthlySub" class="btn btn-danger btn-lg px-5 mb-3 fw-bold">SIGN UP NOW</button>
                              </div>
                            </div>
                          </div>

                          </div>
                          </div>
                          </div>
                          <h4 class="mt-5 text-center"><a href="https://support.newsmaxplus.com/" target="_blank" class="text-black">Need Help? Visit our Help Center for FAQs</a></h4>
          </div>
      </div>
    `;

        // Check if custom content already exists, replace it; otherwise replace the original
        if ($('#startNMPlus').length > 0) {
            $('#startNMPlus').parent().html(htmlContent);
        } else {
            $('.msd__info-box__title').parent().parent().html(htmlContent);
        }

        // Re-attach event handlers
        $('#monthlySub').on('click', function () {
            showModal('checkout_monthly');
        });
        $('#annualSub').on('click', function () {
            showModal('checkout_annually');
        });
    };

    const ModifyPlanDetails = () => {
        var selector = '.msd__account-content';
        var planDetailsFieldObserver = new MutationObserver(mutations => {
            if (window.document.querySelector(selector)) {
                if (window.location.pathname !== "/account")
                    planDetailsFieldObserver.disconnect();

                // Perform actions here!
                if ($('.msd__account-content .msd__info-box__title:contains("No offers yet!")').length > 0) {
                    modifyPlanDetailsContent();
                }
            }
        });

        planDetailsFieldObserver.observe(window.document.body, {
            childList: true,
            subtree: true
        });
    };

    useEffect(() => {
        ModifyMyAccountFields();
        ModifyPlanDetails();
    }, []);

    return (
        <div className="myAccWrapper">
            <Header onGiftToggle={toggleGiftMode} isGiftMode={isGiftMode} />
            <MyAccount />
            <CleengFooter />
        </div>
    );
};

export default AccountPage;
